import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import OnboardingProductFollowButton from './follow-button';

const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin: 6px 0;

  & .loading-panel-content > button {
    height: 20px;
    padding: 2px 0 2px 2px;
    margin-top: 0;
    margin-left: 4px;
    align-items: center;
    border-radius: 0.8px;
    justify-content: normal;
    width: auto;

    ${props => (props.theme.isMobile && `
      background-color: transparent;
    `)}

    > span:not(.icon-lw) {
      font-size: 9px;
      line-height: 16px;
      ${props => (props.theme.isMobile && `
        display: none;
      `)}
      padding: 1px 4px 0;
    }

    > span.icon-lw {
      font-size: 10px;
      padding: 3px;
      ${props => (!props.theme.isMobile && `
        border-radius: 0.8px;
      `)}
    }
  }
`;

const Name = styled.span`
  flex-grow: 2;
  font: ${props => props.theme.fontWeightMedium} 14px/20px ${props => props.theme.fontFamilyBody};
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
`;

const Code = styled.span`
  flex-shrink: 0;
  margin-left: 8px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  width: min-content;
  padding: 0 4px;
  height: 20px;
  background-color: ${props => props.theme.secondaryColor};
  font: ${props => props.theme.fontWeightHeavy} 11px/20px ${props => props.theme.fontFamilyBody};
  border-radius: 2px;
  color: white;
`;

export default function Product(props) {
  return (
    <Container>
      <Name>{props.companyName}</Name>
      <Code>{props.code}</Code>
      <OnboardingProductFollowButton followed={props.followed} stockCodeSlug={props.slug} />
    </Container>
  );
}

Product.propTypes = {
  slug: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  companyName: PropTypes.string.isRequired,
  followed: PropTypes.bool.isRequired,
};
